module.exports = __webpack_public_path__ + "static/img/news_img1.ac85df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/eventsNews/imgs/news_img1.jpg
// module id = hYmv
// module chunks = 1